import { useState, useEffect } from 'react';
import InteractionButtons from './lead-journey/InteractionButtons';
import {useGetInteractions} from '../api/reminder/useGetInteractions.js';

export default function InteractionComponent({leadID, owner}) {

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);

  const [showTable, setShowTable] = useState(false); // Controls whether the table is shown  
  const {lastInteraction, allInteractions, isLoading, refetch} = useGetInteractions({leadID, pageSize, page})


  const handleInteractionAdd = () =>{
    refetch()
  }
  // Close the modal
  const closeModal = () => {
    setShowTable(false);
  };



  return (
    <div className="p-3 md:p-5 flex flex-col bg-white shadow-sm rounded-2xl md:rounded-3xl w-full md:w-1/2 mr-0 md:mr-3 ml-0 md:ml-5">
      <div className="flex justify-between items-center md:items-start w-full border-b border-gray-300 pb-2 mb-3">
          <div className='flex items-center'>
              <img src="/icons/handshake.svg" className='size-5 md:size-7 flex-shrink-0'/>
              <h1 className="font-semibold text-lg md:text-3xl ml-2">Interactions</h1>
          </div>
          {owner && <InteractionButtons leadID={leadID} onInteractionAdd={handleInteractionAdd}/>}
      </div>

      <div className="flex flex-col">
      {/* Display Last Interaction */}
      {lastInteraction ? (
        <div className="mb-3 md:mb-4 w-full">
          <div className='flex justify-between items-start mb-2'>
            <h2 className="text-sm md:text-lg font-normal text-gray-400">Recent Interaction:</h2>
            {/* View All Button */}
            <button
              onClick={() => setShowTable(true)}
              className="text-black underline hover:text-blue-800 focus:outline-none font-bold text-xs md:text-sm flex-shrink-0 min-h-[44px] flex items-center"
            >
              View All
            </button>
          </div>
          <div className='space-y-1'>
            <p className="text-gray-700 font-light text-xs md:text-sm">{lastInteraction.date_of_interaction}</p>
            <p className="text-gray-700 text-base md:text-lg"><strong>{lastInteraction.notes}</strong></p>
            <p className="text-gray-700 text-sm md:text-base">{lastInteraction.contact_method}</p>
          </div>
        </div>
      ) : (
        <p className="text-gray-500 text-sm md:text-base">No interactions available.</p>
      )}
      </div>

      {/* Modal to display the table of all interactions */}
      {showTable && (
          <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-[60] p-4"
            onClick={closeModal}>
              <div className="w-full md:w-[90%] bg-white p-4 md:p-6 rounded-lg shadow-lg max-w-screen max-h-[80vh] overflow-auto"
              onClick={(e) => e.stopPropagation()}>
                <div className="overflow-x-auto mb-4">
                  <div className='pb-3 md:pb-4'>
                    <h2 className="text-lg md:text-xl font-bold mb-2 text-gray-800">Interactions</h2>
                  </div>
                  <table className="min-w-full bg-white border">
                    <thead>
                      <tr className="bg-gray-100 border-none text-neutral-400">
                        <th className="py-2 px-2 md:px-4 text-start text-xs md:text-lg">Contact Method</th>
                        <th className="py-2 px-2 md:px-4 text-start text-xs md:text-lg">Date</th>
                        <th className="py-2 px-2 md:px-4 text-start text-xs md:text-lg">Notes</th>
                        <th className="py-2 px-2 md:px-4 text-start text-xs md:text-lg">Creator</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoading ? (
                        [...Array(3)].map((_, index) => (
                          <tr key={index} className="border-t">
                            <td className="py-2 px-2 md:px-4">
                              <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
                            </td>
                            <td className="py-2 px-2 md:px-4">
                              <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
                            </td>
                            <td className="py-2 px-2 md:px-4">
                              <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
                            </td>
                            <td className="py-2 px-2 md:px-4">
                              <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
                            </td>
                          </tr>
                        ))
                      ) : allInteractions?.interactions && allInteractions.interactions.length > 0 ? (
                        allInteractions.interactions.map((currinteraction) => (
                          <tr key={currinteraction.id} className="border-t">
                            <td className="py-2 px-2 md:px-4 text-xs md:text-base">{currinteraction.contact_method}</td>
                            <td className="py-2 px-2 md:px-4 text-xs md:text-base">{currinteraction.notes}</td>
                            <td className="py-2 px-2 md:px-4 text-xs md:text-base">{currinteraction.date_of_interaction}</td>
                            <td className="py-2 px-2 md:px-4 text-xs md:text-base">{currinteraction.creator_name}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={4} className="py-4 px-2 md:px-4 text-center text-gray-500 text-sm md:text-base">
                            No interactions found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="flex flex-col md:flex-row justify-between items-center gap-3 md:gap-0 p-2">
                        <button
                          onClick={closeModal}
                          className="bg-yellow-300 text-black px-4 py-2.5 rounded hover:bg-yellow-400 text-sm md:text-base font-bold min-h-[44px] w-full md:w-auto"
                        >
                          Close
                        </button>
                      <div className='flex flex-col justify-between items-center w-full md:w-auto'>
                        {/* Pagination */}
                        <div className='px-2 gap-2 flex'>
                            <button
                                onClick={() => setPage(page - 1)}
                                disabled={page === 1}
                                enabled={page === allInteractions?.total_pages}
                                hidden={page === 1}
                                className={`border border-[#1E293B] py-2 px-3 md:px-4 rounded-full text-sm md:text-base min-h-[44px] ${page === 1 ? 'bg-[#1E293B] text-white cursor-not-allowed' : ''}`}
                            >
                                {page - 1 > 0 ? page - 1 : page}
                            </button>
                            <button
                                onClick={() => setPage(page)}
                                disabled={page === allInteractions?.total_pages}
                                className={`${page === page ? 'bg-[#1E293B] text-white' : 'bg-white text-[#1E293B]'} border border-[#1E293B] py-2 px-3 md:px-4 rounded-full text-sm md:text-base min-h-[44px] ${page === allInteractions?.total_pages ? ' cursor-not-allowed' : 'hover:bg-gray-200'}`}
                            >
                                {page}
                            </button>
                            {allInteractions && page < allInteractions.total_pages && (
                                <button
                                    onClick={() => setPage(page + 1)}
                                    className="bg-white text-[#1E293B] border border-[#1E293B] py-2 px-3 md:px-4 rounded-full hover:bg-gray-200 text-sm md:text-base min-h-[44px]"
                                >
                                    {page + 1}
                                </button>
                            )}
                        </div>
                        {allInteractions && (
                          <span className="flex text-xs md:text-sm text-[#94A3B8] pt-3 md:pt-4 text-center">
                                Showing {((page - 1) * pageSize) + 1} to {Math.min(page * pageSize, allInteractions.interactions_count)} of {allInteractions.interactions_count} entries
                          </span>
                        )}
                      </div>
                  </div>
                  
              </div>
            </div>
      )}
    </div>
  );
}